import React from 'react';
import {Link} from 'react-router-dom';
import './TourComponent.scss';

function TourComponent({tour}) {
    const images = tour.images || tour.image; // Adjust to handle both 'images' and 'image'

    if (!tour || !images || images.length < 2) {
        return null; // Return null or handle this case appropriately
    }

    return (
        <div className="card">
            <a>
                <div className="img-frame">
                    <img alt="card-img" src={images[0]} className="text-center img-featured-creator"/>
                </div>
                <div className="frame-bottom">
                    <div>
                        <p className="card-title">{tour.title}</p>
                        <p className="by-creator">{tour.locations.join(', ')}</p>
                    </div>
                    <div className="card-creator-footer">
                        <div className="parameter">
                            <div className="price"></div>
                            <div className="stars">
                                <i className="fa-solid fa-star" style={{color: "#FFD43B"}}></i>
                                <i className="fa-solid fa-star" style={{color: "#FFD43B"}}></i>
                                <i className="fa-solid fa-star" style={{color: "#FFD43B"}}></i>
                                <i className="fa-solid fa-star" style={{color: "#FFD43B"}}></i>
                                <i className="fa-regular fa-star" style={{color: "#FFD43B"}}></i>
                                <span></span>
                            </div>
                            <div className="sales"></div>
                        </div>
                        <div className="button-group">
                            <div className="buttons">
                                <Link to={`/tour/${tour.id}`} className="live-preview">Detail</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}

export default TourComponent;
